import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M19.2 5.375V6.6L4.449 9.47C3.612 9.63625 3 10.3537 3 11.185V13.565C3 14.3963 3.603 15.1138 4.449 15.28L4.8 15.35V17.38C4.8 18.2113 5.403 18.9287 6.24 19.095L9.84 19.8125C10.956 20.04 12 19.2087 12 18.0975V16.75L19.2 18.15V19.375C19.2 19.8562 19.605 20.25 20.1 20.25C20.595 20.25 21 19.8562 21 19.375V5.375C21 4.89375 20.595 4.5 20.1 4.5C19.605 4.5 19.2 4.89375 19.2 5.375ZM10.2 17.065C10.2 17.6163 9.678 18.0362 9.12 17.9225L7.32 17.5637C6.906 17.4762 6.6 17.1262 6.6 16.7062V15.7L10.2 16.4V17.065ZM19.2 16.4L5.52 13.74C5.097 13.6612 4.8 13.3025 4.8 12.8825V11.8675C4.8 11.4475 5.106 11.0888 5.52 11.01L19.2 8.35V16.4Z' />
        </SvgIcon>
    );
});
